(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('timeSheet', {
        templateUrl: 'views/components/views/timeSheet/timeSheet.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            const vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();
